<script lang="ts">
    import { account, saveAccount } from "../lib/stores";
    import DisplaySettings from "./DisplaySettings.svelte";

    export let onlineCount: number = 0;
    export let totalCount: number = 0;

    function logout() {
        account.update((data) => {
            data.isAuthorized = false;
            data.name = "";
            data.password = "";
            return data;
        });
        saveAccount();
    }
</script>

<header
    class="h-12 border-b border-[var(--border)] bg-[var(--background)] flex items-center justify-end gap-1 px-4 sticky top-0 z-40"
>
    <div
        class="flex items-center gap-1.5 mr-1 px-2.5 py-1 rounded-md bg-[var(--card)] border border-[var(--border)] text-xs text-[var(--muted-foreground)]"
        title="Онлайн / всего устройств"
    >
        <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="text-[var(--success)]"
            ><circle cx="8" cy="8" r="3" /></svg
        >
        <span class="text-[var(--foreground)] font-mono">{onlineCount}/{totalCount}</span>
    </div>

    <DisplaySettings />

    <button
        type="button"
        on:click={logout}
        title="Выход"
        class="size-8 inline-flex items-center justify-center rounded-md text-[var(--muted-foreground)] hover:bg-[var(--accent)] hover:text-[var(--destructive)] transition-colors cursor-pointer"
    >
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
    </button>
</header>
